import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'dateTimeFormat'
})

// This pipe is used to convert a UTC date to local date and time

export class DateTimeFormat implements PipeTransform {
    transform(value: Date, format: string): any {
        if (value) {
            if (format) {
                return moment(moment.utc(value).local()).format(format);
            } else {
                return moment(moment.utc(value).local()).format('MMM D, YYYY LT');
            }
        } else {
            return 'No Date';
        }
    }
}
